// Where a signed-in user should land first. Mirrors the Header navigation:
// each entry is a label from GET /api/tabs, the route it opens, and the parent
// label that must also be openable (null for top-level tabs). Order is priority.
const LANDING_CANDIDATES = [
  { label: "Live", path: "/live", parent: "Energy" },
  { label: "Historical", path: "/historical", parent: "Energy" },
  { label: "Off Grid Calculator", path: "/tools/off-grid-calculator", parent: "Energy" },
  { label: "Bill Reconciliation", path: "/bill-reconciliation", parent: "Energy" },
  { label: "Efficiency", path: "/tools/efficiency-initiatives", parent: null },
  { label: "Temperature", path: "/tools/environment", parent: null },
];

export const DEFAULT_LANDING_PATH = "/live";

/**
 * First route the user can actually open, given the /api/tabs payload.
 * A tab counts only if it is present and not "disabled"; a child also needs its
 * parent openable. Falls back to /info (always reachable) when nothing is, and
 * to DEFAULT_LANDING_PATH when there is no usable list (fail open, like Header).
 */
export const resolveLandingPath = (tabs) => {
  const isCurrentShape =
    Array.isArray(tabs) && tabs.length > 0 && tabs.every((tab) => typeof tab.id === "number");
  if (!isCurrentShape) return DEFAULT_LANDING_PATH;

  const openable = new Set(
    tabs.filter((tab) => tab.state !== "disabled").map((tab) => tab.label),
  );

  const match = LANDING_CANDIDATES.find(
    (c) => openable.has(c.label) && (!c.parent || openable.has(c.parent)),
  );
  return match ? match.path : "/info";
};
